import React from 'react'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import styles from './index.module.scss'

export const BackLink: React.FC = () => {
  const router = useRouter()
  const { t } = useTranslation('backlink')

  return (
    <div className={ styles.backlink__container }>
      <a
        onClick={ () => router.back() }
        className={ styles.backlink__link }
      >
        <FontAwesomeIcon
          className={ `fa-fw ${styles.backlink__icon}` }
          icon={ faArrowLeft }
        />
        { t('go_back') }
      </a>
    </div>
  )
}
